import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Internetconnectivity from '../diagnostics/forms/Internetconnectivity';
import Applicationstatus from '../diagnostics/forms/Applicationstatus';
import SystemRestartd from '../diagnostics/forms/SystemRestartd';
import PLCStatus from '../diagnostics/forms/PLCStatus';
import ProxyStatus from '../diagnostics/forms/ProxyStatus';
import UploaderStatus from '../diagnostics/forms/UploaderStatus';
import SystemStatus from '../diagnostics/forms/systemStatus';
import TempSensStatus from '../diagnostics/forms/TempSensStatus';
import Maintenance from './forms/Maintenance';

const ContentCard = ({ content, diagnosticData }) => {
  if (!content) {
    return (
      <div className="bg-gray-100 rounded-lg h-full w-full flex items-center justify-center mx-auto">
        <p className="text-gray-500 text-xs">Select a component to view details</p>
      </div>
    );
  }

  const Icon = content.icon;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={content.id}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="bg-gray-100 p-3 md:p-4 rounded-lg h-full w-full mx-auto flex flex-col"
      >
        <div className="flex items-center gap-3 mb-3 flex-shrink-0">
          <div className="text-blue-800 w-8 h-8 md:w-10 md:h-10">
            <Icon className="w-full h-full" />
          </div>
          <h2 className="text-base md:text-lg font-semibold text-blue-800">{content.title}</h2>
        </div>

        <div className="flex-grow min-h-0 overflow-y-auto custom-scrollbar p-2">
          {/* DYNAMIC WIDTH: Full width for Maintenance, centered max-w-md for others */}
          <div className={content.id === 'Maintenance' ? "w-full" : "max-w-md mx-auto"}>
            {content.id === 'Internetconnectivity' ? (
              <Internetconnectivity diagnosticData={diagnosticData} />
            ) : content.id === 'Application-status' ? (
              <Applicationstatus diagnosticData={diagnosticData} />
            ) : content.id === 'System-Restartd' ? (
              <SystemRestartd diagnosticData={diagnosticData} />
            ) : content.id === 'PLC-Status' ? (
              <PLCStatus diagnosticData={diagnosticData} />
            ) : content.id === 'Proxy-Status' ? (
              <ProxyStatus diagnosticData={diagnosticData} />
            ) : content.id === 'Uploader-Status' ? (
              <UploaderStatus diagnosticData={diagnosticData} />
            ) : content.id === 'PC status' ? (
              <SystemStatus diagnosticData={diagnosticData} />
            ) : content.id === 'Temperature sensor' ? (
              <TempSensStatus diagnosticData={diagnosticData} />
            ) : content.id === 'Maintenance' ? (
              <Maintenance />
            ) : (
              <p className="text-xs text-gray-600">{content.description}</p>
            )}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ContentCard;